export enum ScheduleOptionValueEnum {
	IMMEDIATE = 'immediate',
	SPECIFIC_DATE_TIME = 'specific_date_time',
}

export interface ScheduleOption {
	value: ScheduleOptionValueEnum;
	translationKey: string;
}
